import monitoringSurvey from "@/api/credit-operation/monitoring-survey";
import { baseState, baseMutations } from "@/store/mixins";
import { join } from "lodash";
export const state = {
    ...baseState,
};

export const getters = {};

export const mutations = {
    ...baseMutations,
};

export const actions = {
       fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search,
                    date_between: join(attrubutes.dateRange, ","),
                }
            },
            attrubutes
        );
        return monitoringSurvey.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },
        destroy(context, { id, data }) {
        return monitoringSurvey.destroy(id, data);
    },

};
